var render = function (_h,_vm) {var _c=_vm._c;return _c('SaveButton',_vm._g(_vm._b({staticClass:"delete-button",class:_vm.data.staticClass,attrs:{"danger":""}},'SaveButton',_vm.data.attrs,false),_vm.listeners),[_vm._t("default",[_vm._v("Delete")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }